// @flow
import styled from 'styled-components';
import { display, space, maxWidth } from 'styled-system';
import { PrimaryButton } from 'components/Button';
import { colors, mediaRetina } from '../theme';

export const Button = styled(PrimaryButton)`
  position: relative;
  z-index: ${props => (props.selected ? 1 : 0)};
  color: ${props => (props.selected ? colors.white : colors.battleshipGrey)};
  background-color: ${props =>
    props.selected ? colors.waterBlue : colors.white};
  box-shadow: 0 0 0 1px
    ${props => (props.selected ? colors.waterBlue : colors.silver)} inset;
  border-radius: 0;
  &:first-of-type {
    border-radius: 9999px 0 0 9999px;
  }
  &:last-of-type {
    border-radius: 0 9999px 9999px 0;
  }
  &:hover,
  &:focus {
    color: ${colors.white};
    background-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset;
  }
  &:focus {
    outline: none;
  }
  ${mediaRetina} {
    box-shadow: 0 0 0 1.5px
      ${props => (props.selected ? colors.waterBlue : colors.silver)} inset;
    &:hover,
    &:focus {
      box-shadow: 0 0 0 1.5px ${colors.waterBlue} inset;
    }
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  ${display} ${space} ${maxWidth};
  > * {
    &:not(:first-child) {
      margin-left: -1px;
      ${mediaRetina} {
        margin-left: -2px;
      }
    }
  }
`;

export default ButtonGroup;
